export const LIST_OF_ADDRESS_FIELDS: Array<string> = [
    'street',
    'city',
    'postalCode',
];

export const LIST_OF_STATE_FIELDS: Array<string> = [
    'state',
    'stateAbbreviation',
];

export const LIST_OF_COUNTRY_FIELDS: Array<string> = [
    'country',
    'countryAbbreviation',
];

export const LIST_OF_ALL_ADDRESS_FIELDS: Array<string> = [
    ...LIST_OF_ADDRESS_FIELDS,
    ...LIST_OF_STATE_FIELDS,
    ...LIST_OF_COUNTRY_FIELDS,
]

export const LIST_OF_HQ_STATE_FIELDS: Array<string> = [
    'hqState',
    'hqStateAbbreviation',
];

export const LIST_OF_HQ_COUNTRY_FIELDS: Array<string> = [
    'hqCountry',
    'hqCountryAbbreviation',
];

export const LIST_OF_HQ_FIELDS: Array<string> = [
    'hqStreet',
    'hqCity',
    'hqPostalCode',
    ...LIST_OF_HQ_STATE_FIELDS,
    ...LIST_OF_HQ_COUNTRY_FIELDS,
];
